// extracted by mini-css-extract-plugin
export default {"maindiv":"Plan_maindiv__aAHVh","box":"Plan_box__7-LLP"};